import styled from 'styled-components';
import logo from 'assets/images/Logo.svg';
import { MainButton } from '../common/styles';
/**
 * TODO: colors might come from theme just like design red
 */
export const Container = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  color: ${(props) => props.theme.colors.textPrimary};
  position: relative;
`;

export const MainContainer = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const HederContainer = styled.div`
  width: 100%;
  padding: 0 20px;
`;
export const Logo = styled.div`
  width: 250px;
  height: 125px;
  margin-bottom: 2rem;
  background: url(${logo}) no-repeat center center;
  background-position: left;
`;

export const WelcomeContainer = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  padding: 25px 30px;
  border-radius: ${(props) => props.theme.effects.borderRadiusLarge};
  background: ${(props) => props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlur};
  /* box-shadow removed for TV performance */
  position: relative;
  overflow: hidden;
  transition: ${(props) => props.theme.effects.transitionMedium};
  /* TV Performance Optimizations */
  transform: translateZ(0);
  will-change: auto;
`;

export const WelcomeNoteContainer = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  padding: 20px 25px;
  border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  background: ${(props) => props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  /* box-shadow removed for TV performance */
  margin-top: 15px;
  position: relative;
  transition: ${(props) => props.theme.effects.transitionFast};
  /* TV Performance Optimizations */
  transform: translateZ(0);
  will-change: auto;
`;

export const WelcomeWrapper = styled.div`
  position: absolute;
  ${(props) => (props.isRTL ? 'right: 0;' : 'left: 0;')}
  top: 25%;
  transform: translateY(-50%);
  max-width: 500px;
  width: 100%;
  margin: 0;
  z-index: 10;

  > *:not(:last-child) {
    margin-bottom: 15px;
  }
`;

export const WelcomeText = styled.h1`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
`;

export const WelcomeLabel = styled.span`
  font-size: 2rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary}CC;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`;

export const GuestName = styled.span`
  font-size: 4rem;
  font-weight: 800;
  color: ${(props) => props.theme.colors.textPrimary};
  /* text-shadow removed for TV performance */
  letter-spacing: -0.02em;
  line-height: 1.1;
  margin-top: 8px;
  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

export const NoteWelcomeText = styled.span`
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
  color: ${(props) => props.theme.colors.textPrimary}E6;
  display: block;
  position: relative;
  padding-left: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  left: 0;
  padding: 20px;
  display: flex;
  align-items: flex-end;
  margin-left: auto;
  margin-right: auto;
  max-width: 95%;
  overflow: auto;

  & > *:not(:last-child) {
    margin-inline-end: 15px;
  }
`;

export const Button = styled(MainButton)`
  background: ${(props) =>
    props.active ? props.theme.colors.buttonPrimary : props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  border-radius: ${(props) => props.theme.effects.borderRadiusLarge};
  padding: 2rem 1.5rem;
  min-width: 220px;
  height: 140px;
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.textPrimary};
  transition: ${(props) => props.theme.effects.transitionMedium};
  /* box-shadow removed for TV performance */
  transform: ${(props) =>
    props.active ? 'scale(1.02) translateY(-2px)' : 'scale(1) translateY(0)'};
  position: relative;
  z-index: ${(props) => (props.active ? '4' : '2')};
  flex-shrink: 0;
  overflow: hidden;
  /* TV Performance Optimizations */
  will-change: transform, background;

  &:active {
    transform: ${(props) =>
      props.active ? 'scale(1.01) translateY(-1px)' : 'scale(0.99) translateY(0)'};
    /* box-shadow removed for TV performance */
    transition: ${(props) => props.theme.effects.transitionFast};
  }

  span {
    margin-top: 15px;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    font-weight: 600;
    transition: ${(props) => props.theme.effects.transitionFast};
    color: ${(props) =>
      props.active ? props.theme.colors.textPrimary : props.theme.colors.textInactive} !important;
    /* text-shadow removed for TV performance */
  }
`;

export const MenuButton = styled(MainButton)`
  background: ${(props) =>
    props.active ? props.theme.colors.buttonPrimary : props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  padding: 25px 20px;
  min-width: 200px;
  height: 120px;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary};
  transition: ${(props) => props.theme.effects.transitionMedium};
  transform: ${(props) =>
    props.active ? 'scale(1.04) translateY(-3px)' : 'scale(1) translateY(0)'};
  position: relative;
  z-index: 2;
  flex-shrink: 0;

  &:active {
    transform: scale(0.98) translateY(0);
    /* box-shadow removed for TV performance */
    transition: ${(props) => props.theme.effects.transitionFast};
  }

  span {
    margin-top: 12px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
    transition: ${(props) => props.theme.effects.transitionFast};
  }
`;

export const SidebarContainer = styled.div`
  flex: 1;
  background: ${(props) => props.theme.colors.sidebarBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlur};
  padding: 3rem 2rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.colors.textPrimary};
  font-size: 18px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${(props) => props.theme.colors.glassOverlay};
    pointer-events: none;
  }

  @media (max-height: 899px) {
    font-size: 14px;
    padding: 2rem 1.5rem;
  }
`;

export const WorldClocks = styled.div`
  margin: 1rem 0;
  padding: 1.5rem 1rem;
  border-radius: ${(props) => props.theme.effects.borderRadiusXLarge};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 280px;

  transition: ${(props) => props.theme.effects.transitionMedium};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
  }

  h3 {
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 1rem;
    background: ${(props) => props.theme.colors.textPrimary};
    color: ${(props) => props.theme.colors.textPrimary};
    text-align: center;
  }
`;

export const CityTimeOuter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem 0.75rem;
  margin: 0.25rem;
  background: ${(props) => props.theme.colors.glassBackground};
  border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  border: 1px solid ${(props) => props.theme.colors.glassOverlay};
  min-width: 120px;
  max-width: 150px;
  flex: 1;
  transition: ${(props) => props.theme.effects.transitionMedium};
`;
export const TimeLabel = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary}E6;
  margin-bottom: 0.25rem;
  text-align: center;
  letter-spacing: 0.5px;
`;

export const TimeValue = styled.span`
  font-size: 2rem;
  font-weight: 800;
  background: ${(props) => props.theme.colors.textPrimary};
  color: ${(props) => props.theme.colors.textPrimary};
  /* text-shadow removed for TV performance */
  letter-spacing: -0.02em;
`;

export const AmPm = styled.span`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary}CC;
  margin-inline-start: 0.2em;
  letter-spacing: 0.5px;
`;

export const WeatherBox = styled.div`
  margin: 1rem 0;
  border-radius: ${(props) => props.theme.effects.borderRadiusLarge};

  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 220px;
  max-width: 250px;

  opacity: 0.8;
  transition: ${(props) => props.theme.effects.transitionMedium};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${(props) => props.theme.colors.glassOverlay};
  }

  > div:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const Temperature = styled.div`
  font-size: 3.5rem;
  font-weight: 800;

  color: ${(props) => props.theme.colors.textPrimary};
  /* text-shadow removed for TV performance */
  margin-bottom: 0.25rem;
  letter-spacing: -0.02em;
`;

export const Superscript = styled.sup`
  font-size: 0.2667em;
  vertical-align: super;
`;

export const WeatherRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.textPrimary}E6;
  padding: 0.2rem 0;
  text-align: center;
  line-height: 1.4;

  div {
    background: ${(props) => props.theme.colors.glassBackground};
    padding: 0.3rem 0.6rem;
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
    border: 1px solid ${(props) => props.theme.colors.glassOverlay};
    margin: 0.2rem;
    transition: ${(props) => props.theme.effects.transitionMedium};
  }
`;

export const DateTimeContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  margin-bottom: 1rem;
  min-height: 140px;
  transform: translateY(-40px);
  padding-right: 10px;
`;

export const TimeText = styled.div`
  font-size: 5rem;
  font-weight: 900;
  color: ${(props) => props.theme.colors.textPrimary};
  text-align: center;
  letter-spacing: -0.02em;

  color: ${(props) => props.theme.colors.textPrimary};
  /* text-shadow removed for TV performance */
  line-height: 1;
  margin: 0;
  position: relative;
`;

export const DateText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary}E6;
  /* text-shadow removed for TV performance */
  text-align: right;
  margin-top: 8px;
  opacity: 0.9;
  transition: ${(props) => props.theme.effects.transitionMedium};
  line-height: 1.2;

  @media (max-width: 1200px) {
    font-size: 18px;
    margin-top: 6px;
  }

  @media (max-width: 900px) {
    font-size: 16px;
    margin-top: 5px;
  }

  @media (max-width: 600px) {
    font-size: 14px;
    margin-top: 4px;
  }
`;

// Clock display components
export const ClockDisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 15px;
  width: auto;
  min-width: 120px;
  max-width: 200px;
  flex: 1;
  position: relative;
  overflow: hidden;

  @media (max-width: 1200px) {
    padding: 12px;
    min-width: 100px;
    gap: 8px;
  }

  @media (max-width: 900px) {
    padding: 10px;
    min-width: 80px;
    gap: 6px;
  }

  @media (max-width: 600px) {
    padding: 8px;
    min-width: 60px;
    gap: 4px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    opacity: 0.8;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;

    border-radius: 50%;
    opacity: 0;
    transition: ${(props) => props.theme.effects.transitionMedium};
    z-index: -1;
  }

  &:hover::after {
    opacity: 0.2;
    transform: scale(1.05); /* Reduced from 1.2 for TV performance */
  }
`;

export const ClockCityName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.textPrimary};
  /* text-shadow removed for TV performance */
  text-align: center;
  margin-bottom: 5px;
  transition: ${(props) => props.theme.effects.transitionMedium};

  @media (max-width: 1200px) {
    font-size: 12px;
    margin-bottom: 4px;
  }

  @media (max-width: 900px) {
    font-size: 11px;
    margin-bottom: 3px;
  }

  @media (max-width: 600px) {
    font-size: 10px;
    margin-bottom: 2px;
  }

  &:hover {
    background: ${(props) => props.theme.colors.glassOverlay};
    color: ${(props) => props.theme.colors.textPrimary};
    transform: scale(1.02); /* Reduced from 1.05 for TV performance */
  }
`;

export const ClockContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
  padding: 12px;

  border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
  transition: ${(props) => props.theme.effects.transitionMedium};

  @media (max-width: 1200px) {
    padding: 10px;
    margin: 4px 0;
  }

  @media (max-width: 900px) {
    padding: 8px;
    margin: 3px 0;
  }

  @media (max-width: 600px) {
    padding: 6px;
    margin: 2px 0;
  }

  &:hover {
    transform: translateY(-2px); /* Reduced for TV performance */
  }

  .react-clock {
    background: ${(props) => props.theme.colors.glassBackground};
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    padding: 8px;
    backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
    /* box-shadow removed for TV performance */
    transition: ${(props) => props.theme.effects.transitionMedium};

    @media (max-width: 1200px) {
      padding: 6px;
    }

    @media (max-width: 900px) {
      padding: 5px;
    }

    @media (max-width: 600px) {
      padding: 4px;
    }

    &:hover {
      transform: scale(1.02); /* Reduced for TV performance */
      /* box-shadow removed for TV performance */
    }
  }

  .react-clock__face {
    background: ${(props) => props.theme.colors.glassBackground};
    border: 1px solid ${(props) => props.theme.colors.glassOverlay};
    border-radius: 50%;
  }

  .react-clock__mark,
  .react-clock__mark__body,
  .react-clock__hand,
  .react-clock__hand__body {
    background: ${(props) => props.theme.colors.textPrimary};
    /* box-shadow removed for TV performance */
  }

  .react-clock__second-hand__body {
    background: #e74c3c;
  }

  .react-clock__number {
    color: ${(props) => props.theme.colors.textPrimary};
    /* text-shadow removed for TV performance */
    font-weight: 600;
    font-size: 12px;

    @media (max-width: 1200px) {
      font-size: 10px;
    }

    @media (max-width: 900px) {
      font-size: 9px;
    }

    @media (max-width: 600px) {
      font-size: 8px;
    }
  }
`;
